import { Skeleton } from '@mui/material';
import { EmailNotificationHeader } from './email-notification-header';
import { NotificationSettingsBox } from './notification-settings-box';
import { PushNotificationHeader } from './push-notification-header';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingBars = function LoadingBars() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Array.from(Array(3).keys()).map(function (i) {
      return /*#__PURE__*/_jsx(Skeleton, {
        width: "100%",
        height: 40
      }, i);
    })
  });
};

var LoadingNotificationSettings = function LoadingNotificationSettings() {
  return /*#__PURE__*/_jsxs(NotificationSettingsBox, {
    "data-element": "NotificationSettingsBox",
    "data-component": "LoadingNotificationSettings",
    "data-source-file": "loading.tsx",
    children: [/*#__PURE__*/_jsx(EmailNotificationHeader, {
      "data-element": "EmailNotificationHeader",
      "data-component": "LoadingNotificationSettings",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsx(LoadingBars, {
      "data-element": "LoadingBars",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsx(PushNotificationHeader, {
      "data-element": "PushNotificationHeader",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsx(LoadingBars, {
      "data-element": "LoadingBars",
      "data-source-file": "loading.tsx"
    })]
  });
};

export default LoadingNotificationSettings;